import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {CoerceBoolean} from '../../../../shared/utils/coercion.utils';

@Component({
    selector: 'app-yes-no-input',
    template: `
        <div *ngIf="radioButton else checkBoxComponent" [formGroup]="parentFormGroup">
            <mat-radio-group (change)="valueChangedEvent.emit()" [formControlName]="parentFormControlName">
                <mat-radio-button [value]="true" (focus)="focussed()">{{yesLabel}}</mat-radio-button>
                <mat-radio-button [value]="false" (focus)="focussed()">{{noLabel}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <ng-template #checkBoxComponent>
            <app-checkbox-input [parentFormGroup]="parentFormGroup"
                                [parentFormControlName]="parentFormControlName"></app-checkbox-input>
        </ng-template>
    `
})
export class YesNoInputComponent {

    @Input() @CoerceBoolean() radioButton = false;
    @Input() @CoerceBoolean() checkBox = true;

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;

    @Input() yesLabel = 'Oui';
    @Input() noLabel = 'Non';

    @Output() valueChangedEvent: EventEmitter<number> = new EventEmitter<number>();
    @Output() focussedEvent: EventEmitter<void> = new EventEmitter<void>();

    focussed(){
        this.focussedEvent.emit();
    }
}
